import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const createExternalAuditService = (
  auditObject: any
): Promise<AxiosResponse> => {
  //const company = JSON.parse(localStorage.getItem("company") || "").id;
  //auditObject.company = company;
  const requestingCompany = JSON.parse(
    localStorage.getItem("company") || ""
  ).name;
  auditObject.requestingCompanyName = requestingCompany;
  return axiosAuth.post(API_PATH().apis.auditrequest, auditObject);
};

export const getExternalAuditService = (
  auditObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      //company: JSON.parse(localStorage.getItem("company") || "").id,
    },
  };
  config.params.page = (auditObject.controller.page || 0) + 1;
  config.params.limit = auditObject.controller.limit;
  config.params.searchText = auditObject.searchText;
  if (auditObject?.controller?.sortBy && auditObject?.controller?.sortOrder) {
    config.params.sortBy = auditObject?.controller?.sortBy;
    config.params.sortOrder = auditObject?.controller?.sortOrder;
  }
  if (auditObject?.filter?.statusFilter) {
    config.params.statusFilter = auditObject?.filter?.statusFilter;
  }
  return axiosAuth.get(API_PATH().apis.auditrequests, config);
};

export const getExternalAuditByID = (auditId: any): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      auditRequest: auditId,
    },
  };
  return axiosAuth.get(API_PATH().apis.auditRequestsDetails, config);
};

export const updateExternalAuditService = (
  auditObject: any
): Promise<AxiosResponse> => {
  const userId = JSON.parse(localStorage.getItem("user") || "{}")?.id;
  auditObject.userId = userId;
  auditObject.businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  return axiosAuth.put(API_PATH().apis.auditrequest, auditObject);
};

export const requestExternalVerifierOtp = (
  externalVerifierObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.externalVerifierOtp,
    externalVerifierObject
  );
};

export const requestExternalVerifierResendOtp = (
  externalVerifierObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.externalVerifierResendOtp,
    externalVerifierObject
  );
};

export const externalVerifierOtpVerify = (
  externalVerifierObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.externalVerifierOtpVerify,
    externalVerifierObject
  );
};
